// float_right (PC): chỉ hiện sau khi cuộn qua hết Frame1 (banner).
(function () {
  var fr = document.getElementById("float_right");
  var frame1 = document.getElementById("Frame1");
  if (!fr || !frame1) return;

  function onScroll() {
    // getBoundingClientRect đã tính sẵn transform scale của lib -> toạ độ nhìn thấy
    var bottom = frame1.getBoundingClientRect().bottom;
    // Frame1 gần cuộn hết khỏi màn hình thì hiện nút
    fr.classList.toggle("is-visible", bottom <= 100);
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  window.addEventListener("load", onScroll);
  onScroll();
})();
